<template>
  <b-card>
    <b-row>
      <b-col sm="10">
        <h4>Localização dos Dispositivos</h4>
      </b-col>
      <b-col class="text-right">
        <b-dropdown
          id="dropdown-1"
          right
          variant="flat"
          class="dropdown-icon-wrapper"
        >
          <template #button-content>
            <feather-icon
              icon="AlignJustifyIcon"
              size="16"
              class="align-middle"
            />
          </template>
          <b-dropdown-item @click="onExport('xls')">
            <feather-icon
              icon="PrinterIcon"
              size="18"
            />Dowload XLS
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <Grid
      :fields="fields"
      :items="items"
      :show-border="false"
      :show-search="false"
      :show-loading="isLoading"
      @onChangePage="getData"
    >
      <template #search>

        <b-row>
          <b-col sm="4">
            <i2-form-date-range
              v-model="search.dates"
              label=""
              placeholder="Data de Aprovisionamento"
              @onSelect="onSelect"
              @onClear="onClearData"
            />
          </b-col>
          <b-col sm="4">
            <i2-form-input
              v-model="search.serial"
              label=""
              placeholder="Seriais"
            />
          </b-col>
          <b-col sm="3">
            <organization-select v-model="search.organizations" :multiple="true" :show-label="false" />
          </b-col>
          <b-col sm="1">
            <i2-icon-button
              icon="SearchIcon"
              variant="outline-primary"
              class="mr-1"
              @click="getData"
            />
          </b-col>
        </b-row>
      </template>
      <template #cell(serial)="data">
        <u><span style="font-size: 10pt" @click="onShowDeviceDetails(data.item)">{{ data.item.serial }}</span></u>
      </template>
      <template #cell(unity)="data">
        {{ data.item.organization.path }}
      </template>
      <template #cell(url_location)="data">
        <div class="w-100">
          <a v-if="data.item.longitude" :href="data.item.url_location" target="_blank">
            {{ data.item.url_location }}
          </a>
          <b-badge
            v-if="!data.item.longitude"
            pill
            variant="danger"
          >
            Sem Localização
          </b-badge>

        </div>
      </template>
      <template #cell(last_session)="data">
        {{ data.item.last_session | moment('DD/MM/YYYY') }}
      </template>
    </Grid>
    <device-detail v-model="currentDevice" :show="showDevideDetails" @onClose="onCloseDeviceDetails" />
  </b-card>
</template>

<script>
import moment from 'moment-timezone'
import I2FormDateRange from '@/components/i2/forms/elements/I2FormDateRange'
import DeviceDetailMixin from '@/mixins/DeviceDetailMixin'
import DeviceDetail from '@/components/app/Device/DeviceDetail'
import OrganizationSelect from '@/components/app/Organization/OrganizationSelect'

export default {
  name: 'DevicesLocation',
  components: {
    OrganizationSelect,
    I2FormDateRange,
    DeviceDetail,
  },
  mixins: [DeviceDetailMixin],
  data() {
    return {
      isLoading: false,
      search: {
        start_date: '',
        organizations: [],
        end_date: '',
        query_filter: 'location',
      },
      dates: [],
      date_range: {
        startDate: null,
        endDate: null,
      },
      fields: [
        {
          key: 'serial',
          label: 'Serial',
          class: 'w-2',
        },
        {
          key: 'last_user',
          label: 'Último usuário',
          class: 'w-2',
          sortable: true,
        },
        {
          key: 'last_session',
          label: 'Último acesso',
          class: 'w-2',
          sortable: true,
        },
        {
          key: 'url_location',
          label: 'Última Localização',
          class: 'w-2',
          tdClass: 'truncate-text',
        },
        {
          key: 'city',
          label: 'Cidade',
          class: 'w-2',
          sortable: true,
        },
      ],
      items: { data: [] },
    }
  },

  mounted() {
    this.getData()
  },
  methods: {
    getData(page) {
      this.$http.showLoader = false
      this.isLoading = true
      this.$search.getAsync(
        'devices',
        page,
        this.search,
        null,
      ).then(response => {
        this.$http.showLoader = true
        this.isLoading = false
        this.items = response
      })
    },

    onSelect(data) {
      this.search.start_date = moment(data.startDate).format('YYYY-MM-DD')
      this.search.end_date = moment(data.endDate).format('YYYY-MM-DD')
      this.getData()
    },
    onClearData() {
      this.search.start_date = ''
      this.search.end_date = ''
      this.getData()
    },
    async onExport(format) {

      const response = await this.$search.get(
        'devices/export?report=location',
        null,
        this.search,
        null,
      )
      if (response.url !== '') {
        window.open(response.url, '_blank')
        return
      }
      this.$notify.success(response.message)
    },

  },

}
</script>

<style scoped>

</style>
